import { render, staticRenderFns } from "./power-factor.vue?vue&type=template&id=8e829326&scoped=true"
import script from "./power-factor.vue?vue&type=script&lang=js"
export * from "./power-factor.vue?vue&type=script&lang=js"
import style0 from "./power-factor.vue?vue&type=style&index=0&id=8e829326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e829326",
  null
  
)

export default component.exports